import "./App.scss";
import { Switch, Route, Redirect,useLocation } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";
import { AnimateSharedLayout, AnimatePresence } from "framer-motion";
import { useStateValue } from "./context/StateProvider";
import { useEffect, useRef } from "react";
import { getProducts,getUser} from "./utils/onLoad";
import LoadingBar from "react-top-loading-bar";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import ProductScreen from "./screens/ProductScreen";
import CartScreen from "./screens/CartScreen";
import WishlistScreen from "./screens/WishlistScreen";
import UserScreen from "./screens/UserScreen";
import PaymentScreen from "./screens/PaymentScreen";
function App() {
  const [{ user, cart }, dispatch] = useStateValue();
  const location = useLocation();
  const loadingBar = useRef(null);

  useEffect(() => {
    loadingBar.current.continuousStart();
    getUser(dispatch)
    getProducts(dispatch, loadingBar);
  }, [dispatch]);
  return (
    <div className="app">
      <LoadingBar height={3} color="#f90" ref={loadingBar} shadow={true} />
      <Sidebar />
      <div className="app__inner">
        <AnimatePresence exitBeforeEnter>
          <AnimateSharedLayout>
            <Header />
            <Switch location={location} key={location.pathname}>
              <Route exact path="/product/:id">
                <ProductScreen />
              </Route>
              <Route exact path="/">
                <HomeScreen />
              </Route>
              <Route exact path="/wishlist">
                <WishlistScreen />
              </Route>
              <Route exact path="/cart">
                <CartScreen />
              </Route>
              <Route path="/login">
                <UserScreen type="login" />
              </Route>
              <Route path="/signup">
                <UserScreen type="signup" />
              </Route>
              <Route path="/welcome">
                <UserScreen type="welcome" />
              </Route>
              <Route path="/password-reset">
                <UserScreen type="passwordReset" />
              </Route>
              <Route path="/profile">
                <UserScreen type="profile" />
              </Route>
              <Route path="/payment">
                  <PaymentScreen/>
              </Route>
              <Route eaxact path="/success">
              <Redirect to="/" />
              </Route>
            </Switch>
          </AnimateSharedLayout>
        </AnimatePresence>
      </div>
    </div>
  );
}

export default App;
